import OgTwitterImage from "@assets/jpg/og-twitter-image.jpg";

import { ERoutes } from "@utils/constants";

const indexedPage = (overrides: Record<string, any> = {}) => {
  const { extra: extraOverrides, ...rest } = overrides;
  return {
    title: "helmet.title",
    description: "helmet.description",
    link: "helmet.link",
    siteName: "helmet.siteName",
    twitterSite: "helmet.twitterSite",
    extra: {
      "og:image": OgTwitterImage,
      "og:type": "website",
      "twitter:card": "summary_large_image",
      "twitter:image": OgTwitterImage,
      viewport: "width=device-width, initial-scale=1",
      ...extraOverrides,
    },
    ...rest,
  };
};

const noindexPage = {
  description: undefined,
  link: undefined,
  siteName: undefined,
  twitterSite: undefined,
  extra: {
    viewport: "width=device-width, initial-scale=1",
    "og:image": undefined,
    "og:type": undefined,
    "twitter:card": undefined,
    "twitter:image": undefined,
    robots: "noindex, nofollow",
  },
};

export const helmetConfig = {
  // Priority 1.0 — Main pages
  [ERoutes.Home]: indexedPage({}),
  [ERoutes.Catalog]: indexedPage({
    title: "helmet.catalog.title",
    description: "helmet.catalog.description",
    link: "helmet.catalog.link",
  }),
  [ERoutes.CatalogLandingFreeBackground]: indexedPage({
    title: "helmet.freeBg.title",
    description: "helmet.freeBg.description",
    link: "helmet.freeBg.link",
  }),
  [ERoutes.FreeYoutubeMusic]: indexedPage({
    title: "helmet.freeYoutube.title",
    description: "helmet.freeYoutube.description",
    link: "helmet.freeYoutube.link",
  }),
  [ERoutes.CatalogLandingLicensing]: indexedPage({
    title: "helmet.licensing.title",
    description: "helmet.licensing.description",
    link: "helmet.licensing.link",
  }),
  [ERoutes.FreeUseTerms]: indexedPage({}),

  // Priority 0.9 — Important subpages
  [ERoutes.MUSIC_CREATOR_PROGRAM]: indexedPage({}),
  [ERoutes.Contact]: indexedPage({}),
  [ERoutes.Licensing]: indexedPage({}),

  // Priority 0.8 — Secondary pages
  [ERoutes.Newsletter]: indexedPage({}),
  [ERoutes.DownloadInstruction]: indexedPage({}),

  // Priority 0.7 — Tertiary pages
  [ERoutes.Submit]: indexedPage({}),
  [ERoutes.Deals]: indexedPage({}),

  // Dynamic pages — albums and tracks
  [ERoutes.Album]: indexedPage({
    title: "helmet.album.title",
    description: "helmet.album.description",
    link: "helmet.album.link",
    extra: { "og:type": "music.album" },
  }),
  [ERoutes.Track]: indexedPage({
    extra: { "og:type": "music.song" },
  }),

  // Noindex pages — user-only or legal
  [ERoutes.Profile]: noindexPage,
  [ERoutes.Favorites]: noindexPage,
  [ERoutes.Conditions]: noindexPage,
  [ERoutes.Imprint]: noindexPage,
  [ERoutes.Privacy]: noindexPage,
} as const;
